/** Tooltip copy for Leads Management — aligned with management report metric definitions */

export const leadsHelp = {
  page: {
    title: 'Leads Management',
    body: 'Work queue for active leads. Enrolled leads (Won) are hidden by default — they appear under Students. Counts in Sales reports use the same lead date rule when you filter by date range.',
  },
  listCount: {
    title: 'List count',
    body: 'Number of leads matching your filters on this page. By default, enrolled (Won) leads are excluded so you see the pipeline only.',
  },
  leadDateFrom: {
    title: 'Lead date from',
    body: 'Uses lead acquired date when set; otherwise the date the lead was created. Same rule as “Leads” in Sales & Enrollment reports.',
  },
  leadDateTo: {
    title: 'Lead date to',
    body: 'End of the lead date range (acquired date, or created date if acquired is empty).',
  },
  periodSummary: {
    title: 'Period summary',
    body: 'Breakdown for the selected date range and filters. Active = pipeline leads shown in the list. Enrolled (acquired in period) = Won leads acquired in this range. Total acquired matches the “Leads” column in Sales reports.',
  },
  enrollmentsClosed: {
    title: 'Enrollments closed',
    body: 'Leads marked Won during this date range (from status history). May include leads acquired in an earlier month. Matches the “Enrollments” column in Sales reports.',
  },
  statusFilter: {
    title: 'Status filter',
    body: 'Choose Won to see enrolled leads only. Clear status to return to the default pipeline view (excludes Won).',
  },
};

export default leadsHelp;
